import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3ab9e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = { class: "ws_ml15" }
const _hoisted_4 = { class: "tip ws_mt10" }
const _hoisted_5 = {
  key: 1,
  class: "success"
}
const _hoisted_6 = { class: "ws_ml15" }
const _hoisted_7 = { class: "ws_mt10" }
const _hoisted_8 = { class: "dialog-footer" }

import { ref, computed, watch } from 'vue'
import { CODE_ENUM, SUFFIX } from '@/common'
import { queryDeviceBatchTemplate } from '@/api'
import { isEmpty } from 'lodash'
import { downLoadFile } from '@/utils'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'batch-device',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const uploadRef = ref()

const { VUE_APP_BASE_URL } = process.env
const uploadAction = computed(() => {
  return VUE_APP_BASE_URL + SUFFIX.DCOP + '/device/info/add/import'
})

const uploadHeaders = {
  Authorization: 'Bearer ' + localStorage.getItem('WX_Authorization'),
}

const responseInfo = ref({
  fileName: '',
  type: '',
  msg: '',
})
const loading = ref(false)

const handleUploadSuccess = (res: any, file: any) => {
  loading.value = false

  if (res?.code === CODE_ENUM.SUCCESS) {
    responseInfo.value = {
      fileName: file.name,
      type: 'success',
      msg: res.msg,
    }
    $emit('success')
  } else if (res?.code === 1) {
    responseInfo.value = {
      fileName: file.name,
      type: 'error',
      msg: res.msg.split('\n'),
    }
  } else {
    ElMessage.error(res?.msg || '上传失败，请重新上传')
  }
}
const onProgress = () => {
  loading.value = true
}
const handleUploadError = (response: any) => {
  loading.value = false
  ElMessage.error('上传失败，请重新上传')
}

const downlownTemplate = async () => {
  const res: any = await queryDeviceBatchTemplate()
  if (res?.msg?.code === CODE_ENUM.SUCCESS) {
    downLoadFile(res)
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  responseInfo.value = {
    fileName: '',
    type: '',
    msg: '',
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "批量添加设备",
    width: "480",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_upload, {
          ref_key: "uploadRef",
          ref: uploadRef,
          headers: uploadHeaders,
          action: uploadAction.value,
          "show-file-list": false,
          "on-success": handleUploadSuccess,
          "on-error": handleUploadError,
          "on-progress": onProgress
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { plain: "" }, {
              default: _withCtx(() => [
                _createTextVNode("上传文件")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action"]),
        _createElementVNode("a", {
          class: "ws_ml24",
          onClick: downlownTemplate
        }, "下载模版")
      ]),
      (responseInfo.value.type === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, [
              _createVNode(_component_el_icon, {
                color: "#F56C6C",
                size: "14px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CircleCloseFilled)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_3, "解析完成-" + _toDisplayString(responseInfo.value.fileName), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responseInfo.value.msg, (v, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(v), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (responseInfo.value.type === 'success')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", null, [
              _createVNode(_component_el_icon, {
                color: "#67C23A",
                size: "14px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CircleCloseFilled)
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_6, "解析完成-" + _toDisplayString(responseInfo.value.fileName), 1)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(responseInfo.value.msg), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})